import * as _ from 'lodash';

_.mixin({
    'numberFormat': function(num, decimals = 2, thousandsSeparator = "'")
    {
        return num.toFixed(decimals).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1"+thousandsSeparator);
    }
});